import { BaseSongResponse } from '../../responses/responseTypes';
import { SongType } from './enums';
import { IBaseSong } from './interfaces';

/** Class with shared properties among all different types of songs that we use through the application. */

export abstract class BaseSong implements IBaseSong {
  songType: SongType;

  id: string;

  title: string;

  duration: number;

  musicFilePath: string;

  isInLibrary: boolean;

  wavFilePath: string | null;

  constructor(songType: SongType, data: BaseSongResponse) {
    this.songType = songType;

    this.id = data.id;
    this.title = data.title;
    this.duration = data.duration;
    this.isInLibrary = data.is_in_library;
    this.musicFilePath = data.music_file_path;
    this.wavFilePath = data.wav_file_path ?? null;
  }
}
